// components
import { PATH_DASHBOARD } from "@/app/routes/paths";
import SvgColor from "@/core/components/svg-color";
import sliceNames from "@/redux/names";

// ----------------------------------------------------------------------

const icon = (name) => (
  <SvgColor
    src={`/assets/icons/navbar/${name}.svg`}
    sx={{ width: 1, height: 1 }}
  />
);

const ICONS = {
  blog: icon("ic_blog"),
  cart: icon("ic_cart"),
  chat: icon("ic_chat"),
  mail: icon("ic_mail"),
  user: icon("ic_user"),
  file: icon("ic_file"),
  lock: icon("ic_lock"),
  label: icon("ic_label"),
  blank: icon("ic_blank"),
  kanban: icon("ic_kanban"),
  folder: icon("ic_folder"),
  banking: icon("ic_banking"),
  booking: icon("ic_booking"),
  invoice: icon("ic_invoice"),
  calendar: icon("ic_calendar"),
  disabled: icon("ic_disabled"),
  external: icon("ic_external"),
  menuItem: icon("ic_menu_item"),
  ecommerce: icon("ic_ecommerce"),
  analytics: icon("ic_analytics"),
  dashboard: icon("ic_dashboard"),
};

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: "dashboard.root",
    items: [
      {
        title: "dashboard.root",
        permissionProp: sliceNames.stat,
        path: PATH_DASHBOARD.app,
        icon: ICONS.dashboard,
      },
    ],
  },
  {
    subheader: "app.sales",
    items: [
      {
        title: "product.root_plural",
        path: PATH_DASHBOARD.products.root,
        icon: ICONS.cart,
      },
      {
        title: "order.root_plural",
        path: PATH_DASHBOARD.orders.root,
        icon: ICONS.invoice,
      },
      {
        title: "provisioning.root",
        path: PATH_DASHBOARD.provisioning.root,
        icon: ICONS.file,
      },
      {
        title: "articleCategory.root_plural",
        path: PATH_DASHBOARD.articleCatigories.root,
        icon: ICONS.folder,
      },
    ],
  },
  {
    subheader: "app.accounts",
    items: [
      {
        title: "customer.root_plural",
        path: PATH_DASHBOARD.customers.root,
        icon: ICONS.booking,
      },
      {
        title: "ambassadeur.root_plural",
        path: PATH_DASHBOARD.ambassadeur.root,
        icon: ICONS.booking,
      },
    ],
  },
  {
    subheader: "grade.root_plural",
    items: [
      {
        title: "grade.root_plural",
        path: PATH_DASHBOARD.grades.root,
        icon: ICONS.booking,
      },
    ],
  },
  {
    subheader: "app.payment",
    items: [
      {
        title: "paymentRequest.root_plural",
        path: PATH_DASHBOARD.paymentRequests.root,
        icon: ICONS.cart,
      },
    ],
  },
];

export default navConfig;
